import Immutable from 'immutable';

export const MIN_NAV_BAR_WINDOW_WIDTH = 1024;

export const updateQualificationCourseEnrolments = (
  qualification,
  enrolments
) => {
  const setEnrolment = (course) => {
    const isEnrolled = enrolments.has(course.get('path'));
    return course.set('isEnrolled', isEnrolled);
  };

  let qualificationData = qualification;
  qualificationData = qualificationData.set(
    'coreCourses',
    qualificationData.get('coreCourses').map(setEnrolment)
  );
  qualificationData = qualificationData.set(
    'electiveCourses',
    qualificationData.get('electiveCourses').map(setEnrolment)
  );

  return qualificationData;
};

export const filterDeletedCourseOutcomes = (course) => {
  const outcomes = course
    .get('outcomes')
    .filter((outcome) => !outcome.get('isDeleted', false));
  return course.set('outcomes', outcomes);
};

export const defaultStrings = new Immutable.Map({
  course: 'course',
  qualification: 'qualification',
  'course objective': 'course objective',
  'course outcomes': 'course outcomes',
});
